import { Route } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { SignOutResolver } from './core/auth/sign-out.resolver';
import { LayoutComponent } from './layout/layout.component';
import { SignInComponent } from './modules/auth/sign-in/sign-in.component';
import { InitialDataResolver } from './app.resolvers';
import { PermissionGuard } from './core/permission/permission.guard';

export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },

    {
        path: 'sign-in',
        component: SignInComponent,
        canActivate: [NoAuthGuard],
    },

    {
        path: 'auth/callback',
        loadComponent: () =>
            import('./modules/auth/sso-callback/sso-callback.component').then(
                (m) => m.SsoCallbackComponent,
            ),
    },

    {
        path: 'pending-verification',
        loadComponent: () =>
            import(
                './modules/auth/pending-verification/pending-verification.component'
            ).then((m) => m.PendingVerificationComponent),
        canActivate: [AuthGuard],
    },

    {
        path: 'complete-profile',
        loadComponent: () =>
            import(
                './modules/auth/complete-profile/complete-profile.component'
            ).then((m) => m.CompleteProfileComponent),
        canActivate: [AuthGuard],
    },

    {
        path: 'sign-out',
        canActivate: [AuthGuard],
        resolve: { action: SignOutResolver },
        children: [],
    },

    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('./modules/dashboard/dashboard.module').then(
                        (m) => m.DashboardModule,
                    ),
            },
            {
                path: 'profile',
                loadChildren: () =>
                    import('./modules/profile/profile.module').then(
                        (m) => m.ProfileModule,
                    ),
            },
            {
                path: 'users',
                loadChildren: () =>
                    import('./modules/users/users.module').then(
                        (m) => m.UsersModule,
                    ),
                canActivate: [PermissionGuard],
                data: {
                    permission: [
                        'user.read',
                        'users.read',
                        'user.verify',
                        'role.read',
                        'roles.read',
                        'permission.read',
                        'permissions.read',
                        'user.*',
                        'role.*',
                        'permission.*',
                        '*',
                    ],
                },
            },
            {
                path: 'roles',
                redirectTo: 'users/roles',
                pathMatch: 'full',
            },
            {
                path: 'permissions',
                redirectTo: 'users/permissions',
                pathMatch: 'full',
            },
            {
                path: 'master-data',
                loadChildren: () =>
                    import('./modules/master-data/master-data.module').then(
                        (m) => m.MasterDataModule,
                    ),
                canActivate: [PermissionGuard],
                data: {
                    permission: [
                        'division.read',
                        'divisions.read',
                        'company.read',
                        'companies.read',
                        'division.*',
                        'company.*',
                        'user.read',
                        'users.read',
                        'user.*',
                        'users.*',
                    ],
                },
            },
            {
                path: 'self-service',
                loadChildren: () =>
                    import('./modules/self-service/self-service.module').then(
                        (m) => m.SelfServiceModule,
                    ),
            },
            {
                path: 'approvals',
                loadChildren: () =>
                    import('./modules/approvals/approvals.module').then(
                        (m) => m.ApprovalsModule,
                    ),
            },
            {
                path: '403',
                loadComponent: () =>
                    import('./modules/error/error-403/error-403.component').then(
                        (m) => m.Error403Component,
                    ),
            },
        ],
    },

    // Fallback 404
    {
        path: '**',
        redirectTo: 'sign-in',
    },
];
